<template>
  <div class="report-position-wrapper">
    <div class="report-position-container" v-if="isComplete">
    <div v-if="reqdata">
      <img :src="getBrandThemeURL('estimate/reportPosition/header_bg.png')" class="banner" />
      
      <div class="main-content">
        <div class="content-box">
          <div class="right-text">{{ reqdata.title || reqdata.info.title }}</div>
          <div class="sub-title-text">{{ reqdata.subtitle || reqdata.info.subtitle }}</div>
          
          <div class="score-img-box">
            <img :src="getBrandThemeURL('estimate/reportPosition/score_left.png')" class="img-score" />
            <div class="padding-style" style="margin-top: -0.4rem">
              <div v-if="reqdata.is_completed == 1" class="number-box" style="margin-top: 0;">
                <div class="number-all">
                  {{ reqdata.user_rank }}<span class="gray-score">/{{ reqdata.total_number_participants }}</span>
                </div>
              </div>
              <div v-else class="gray-title">-</div>
              <div  class="special-text">同岗位总分排名</div>
            </div>
            <img :src="getBrandThemeURL('estimate/reportPosition/score_right.png')" class="img-score" />
          </div>
          
          <div class="tips-msg-txt" v-if="reqdata.completed_tips_msg">{{ reqdata.completed_tips_msg }}</div>
            <div class="score-box">
            <div class="score-center-box mt0">
              <div class="score-item">
                <div class="score-item-t">
                    {{ reqdata.total_score || '-' }}
                </div>
                <div class="score-item-b">
                  总分
                </div>
              </div>
              <div class="score-item">
                <div class="score-item-t">{{ reqdata.average_score || '-' }}</div>
                <div class="score-item-b">平均分</div>
              </div>
              <div class="score-item">
                <div class="score-item-t">
                  <span class="score-item-h" v-if="reqdata.is_completed == 1 && reqdata.defeat_the_examinees">{{ reqdata.defeat_the_examinees }}</span>
                  <span v-else>-</span>
                </div>
                <div class="score-item-b">击败考生</div>
              </div>
            </div>
          </div>
          <div class="tips-box" v-if="reqdata.ing_tips_msg">{{ reqdata.ing_tips_msg }}</div>
          <div class="list-area" v-if="reqdata.item_group_paper_data && reqdata.item_group_paper_data.length">
            <div class="list-item" v-for="(item, index) in reqdata.item_group_paper_data" :key="index">
              <div class="left">
                <img :src="item.icon" class="img" />
                <div class="text">{{ item.title }}</div>
              </div>
              <div class="right">
                <template v-if="item.status === 1">
                  <div class="num">{{ item.score }}</div>
                  <div class="text">分</div>
                </template>
                <template v-else-if="item.status === 2">
                  <div class="red-text">{{ item.start_time }}</div>
                </template>
                <template v-else-if="item.status === 3">
                  <div class="yellow-text">报告生成中…</div>
                </template>
                <template v-else>
                  <div class="gray-text">待估分</div>
                </template>
              </div>
            </div>
          </div>
          <div class="msg-txt" v-if="reqdata.total_score_tips_msg">{{ reqdata.total_score_tips_msg }}</div>
        </div>
        
        <div class="same-job-rank">
          <div class="top-pd-style">
            <div class="title-area">
              <img src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/result/goal.png" class="img" />
              <div class="title">同岗位排行榜</div>
            </div>
          </div>
          <div class="top-area">
            <div class="list-item" v-for="(item, index) in reqdata.job_info_list" :key="index">
              <div class="left-text">{{ item.title }}</div>
              <div class="right-text">{{ item.value }}</div>
            </div>
          </div>
          <div class="top-pd-style">
            <div class="line"></div>
          </div>
          <div class="score-rank-box" ref="scrollView">
            <div class="scroll-list">
              <div 
                :id="item.active_key"
                :class="['scroll-list-item', { active: activeId == item.active_key }]"
                v-for="(item, index) in reqdata.tab_lists" 
                :key="index" 
                @click="setRank(item.active_key)"
              >
                <span>{{ item.tab_name }}</span>
                <img 
                  v-if="activeId == item.active_key"
                  :src="getBrandThemeURL('estimate/reportPosition/arrow.png')"
                  class="img" 
                />
              </div>
            </div>
          </div>
          <div class="menu-content">
            <div class="rank-list">
              <div class="rank-top">
                <div 
                  :class="['tit', item.field === 'user' ? 'center' : item.field === 'rank' ? 'rank-style' : 'score-style']"
                  v-for="(item, index) in activeTabItem.head_lists" 
                  :key="index"
                >
                  {{ item.title }}
                </div>
              </div>
              <div 
                class="rank-item"
                v-for="(item, index) in activeTabItem.lists" 
                :key="index"
              >
                <template v-for="(headItem, headIndex) in activeTabItem.head_lists">
                  <template v-if="headItem.field === 'rank'">
                    <div class="number">
                      <img
                        class="img"
                        v-if="item.rank === 1" 
                        src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/rank/first.png" 
                      />
                      <img
                        class="img"
                        v-else-if="item.rank === 2" 
                        src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/rank/second.png" 
                      />
                      <img
                        class="img"
                        v-else-if="item.rank === 3" 
                        src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/rank/third.png" 
                      />
                      <template v-else>
                        {{ item.rank }}
                      </template>
                    </div>
                  </template>
                  <template v-else-if="headItem.field === 'user'">
                    <div class="user">
                      <img :src="item.user.head_icon" class="imgbox" />
                      <div class="name">{{ item.user.nickname }}</div>
<!--                      <div class="me" v-if="item.user.is_my === 1">我</div>-->
                    </div>
                  </template>
                  <div v-else class="score-s">{{ item[headItem.field] }}</div>
                </template>
              </div>
            </div>
            <div v-if="!activeTabItem.is_view" class="fix-bg" style="background-image: url(https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/result/rank_bg.png)">
              {{ activeTabItem.view_msg }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer-box" v-if="paperObj && paperObj.paper_id">
        <div class="all-btn" @click="goTest(paperObj.paper_id)">开始{{ paperObj.title }}估分</div>
      </div>
      
      <div v-if="tipShow" class="share-tip-overlay">
        <div class="maks-box" @click="closShare"></div>
        <img src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/result/share_line.png" class="lines" :style="'top: 5px;right:' + right" />
        <img src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/result/share_tip.png" class="tips" style="top: 184px;" />
      </div>
<!--      <div class="share-box" @click="openShare">-->
<!--        <img src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/rank/share.png" />-->
<!--      </div>-->
    </div>
    
    <!-- 暂无估分报告 -->
    <div v-else class="no-data-container">
      <div class="no-data-content">
        <img src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/default/home_default.png" class="no-data-img" />
        <div class="no-data-text">正在为你生成估分报告，请稍候</div>
      </div>
      <div class="refresh-btn" @click="refreshReport">刷新</div>
    </div>
  </div>
  
  <!-- 分享弹窗 -->
  <van-action-sheet v-model="shareShow" :actions="shareActions" @select="btnClick" cancel-text="取消" />
  
  <!-- 引导页 -->
  <van-action-sheet v-model="show" :actions="[]" cancel-text="取消">
    <template slot="title">
      <div class="title-box">
        <img 
          src="https://mpresource-1253756937.cos.ap-chengdu.myqcloud.com/jbc_estimate_exam/home/close.png" 
          @click="openClose" 
          class="close" 
        />
        <img 
          v-if="reqdata && reqdata.instruct && reqdata.instruct.cmd && reqdata.instruct.cmd.option && reqdata.instruct.cmd.option.param && reqdata.instruct.cmd.option.param.img"
          :src="reqdata.instruct.cmd.option.param.img"
          class="img-w"
        />
      </div>
    </template>
  </van-action-sheet>
  
  <FooterOpenApp
    v-if="isComplete && reqdata"
    ref="footer_open_app"
    :name="getCurrentBrand.name"
    :logoImage="getCurrentBrand.imageLogoURL"
    :replace_id="reqdata.item_id"
    text="参与考试估分"
    :schemaUnitKey="schemaUnitKey"
    buttonText="打开"
  />
  </div>
</template>

<script>
import CollapseKnowledge from './components/CollapseKnowledge.vue'
import AnswerSheet from './components/AnswerSheet.vue'
import ReportLineChart from './components/ReportLineChart.vue'
import commnMixin from '@/mixin/commn'
import {getReportPositionApi} from "@/api/estimate";
import FooterOpenApp from "@/components/FooterOpenApp.vue";

export default {
  name: 'ReportPosition',
  mixins: [commnMixin],
  components: {
    FooterOpenApp,
    CollapseKnowledge,
    AnswerSheet,
    ReportLineChart,
  },
  data() {
    return {
      isComplete: false,
      reqdata: null,
      right: '',
      tipShow: false,
      canvasData: {},
      groupList: [],
      advertShow: false,
      show: false,
      activeId: 'item1',
      hasCompelete: false,
      paperObj: {},
      shareShow: false,
      shareActions: [
        { name: '微信好友', icon: 'weixin' },
        { name: '朋友圈', icon: 'friend' },
      ],
      schemaUnitKey: 'EstimateScoreDetail',
    }
  },
  computed: {
    activeTabItem() {
      return this.getActiveList(this.activeId, this.reqdata?.tab_lists || [])
    },
    distributionMapScoreArray() {
      return this.reqdata?.distribution_map?.score_map || []
    },
    answerSheetData() {
      if (!this.reqdata?.record?.exam_record?.answer || !this.groupList.length) {
        return []
      }
      // 格式化答题卡数据
      return this.formatAnswerSheetData(
        this.groupList,
        this.reqdata.record.exam_record.answer
      )
    },
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      const query = this.$route.query
      // 计算分享按钮位置
      this.right = '20px'
      this.getReport()
    },
    // 格式化秒数为符号格式
    formatSecondsToSymbol(seconds) {
      const totalSeconds = parseInt(seconds) || 0
      if (isNaN(totalSeconds) || totalSeconds < 0) {
        return "0''"
      }
      
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const secs = totalSeconds % 60
      
      const parts = []
      if (hours > 0) {
        const hoursStr = hours < 10 ? "0" + hours : hours
        parts.push(hoursStr + "°")
      }
      if (minutes > 0) {
        const minutesStr = minutes < 10 ? "0" + minutes : minutes
        parts.push(minutesStr + "'")
      }
      const secsStr = secs < 10 ? "0" + secs : secs
      parts.push(secsStr + "''")
      
      return parts.join("")
    },
    // 获取激活的列表项
    getActiveList(key, arr) {
      const obj = {}
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        if (item && item.active_key == key) {
          return item
        }
      }
      return obj
    },
    // 格式化答题卡数据
    formatAnswerSheetData(groupList, answer) {
      return groupList.map((group, index) => {
        const list = (group.list || []).map((questionId, qIndex) => {
          const r = answer[questionId]?.r || 0
          return {
            id: questionId,
            r: parseInt(r),
            countIndex: qIndex + 1,
          }
        })
        return {
          title: group.title || `第${index + 1}组`,
          list,
        }
      })
    },
    // 设置排名
    setRank(id) {
      this.activeId = id
      this.$nextTick(() => {
        // 滚动到对应位置
        const element = document.getElementById(id)
        if (element && this.$refs.scrollView) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
        }
      })
    },
    // 去测试
    goTest(paperId) {
      this.$router.push({
        path: '/question',
        query: {
          paper_id: paperId,
        },
      })
    },
    // 查看解析
    seeAnalysis() {
      this.$router.push({
        path: '/question',
        query: {
          record_id: this.reqdata.record.record_id,
          viewType: 'record',
        },
      })
    },
    // 打开排名
    openRanking(info) {
      this.$router.back()
    },
    // 打开分享
    openShare() {
      this.tipShow = true
    },
    // 关闭分享
    closShare() {
      this.tipShow = false
    },
    // 分享按钮点击
    btnClick(action) {
      // 处理分享逻辑
      this.shareShow = false
      this.closShare()
    },
    // 关闭引导页
    openClose() {
      this.show = false
    },
    // 刷新报告
    refreshReport() {
      this.getReport()
    },
    // 获取单科报告
    async getSingleReport() {
      try {
        const params = this.routeFixedParam({
          paper_id: this.$route.query.paper_id,
        })
        // TODO: 调用API获取单科报告数据
        // const res = await getSubjectReportApi(params)
        // this.reqdata = res.data
        this.isComplete = true
      } catch (error) {
        console.error('getSingleReport error', error)
        this.isComplete = true
      }
    },
    // 获取报告
    async getReport() {
      try {
        const params = {
          record_id: this.$route.query.record_id,
        }
        // TODO: 调用API获取报告数据
        const res = await getReportPositionApi(params)
        this.reqdata = res.data
        if (res.data.tab_lists && res.data.tab_lists.length) {
          this.activeId = res.data.tab_lists.find(item => item.is_active)?.active_key || res.data.tab_lists[0].active_key
        }
        const pageTitle = res.data?.title || '估分报告'
        document.title = pageTitle
        // 设置分享标题
        this.$util.setShare({
          title: pageTitle,
          desc: `快来看看我的估分报告，一起对答案吧！`,
          link: window.location.href,
          imgUrl:
              'https://training-1253756937.cos.ap-chengdu.myqcloud.com/commonImage/Admin/estimate_item/image/2024-3-15/44365645878.png' ||
              '',
        })
        this.isComplete = true
        this.$nextTick(() => {
          if (this.$refs.footer_open_app) {
            this.$refs.footer_open_app.updateConfig(this.reqdata.item_id)
          }
          if(window?.tikuWeb?.setShareHtml) {
            console.log('11111')
            const headHtml = document.getElementsByTagName('head')[0].innerHTML;
            const fullHeadHtml = `<head>${headHtml}</head>`;
            window.tikuWeb.setShareHtml(fullHeadHtml);
          }
        })
      } catch (error) {
        console.error('getReport error', error)
        this.isComplete = true
      }
    },
  },
}
</script>

<style scoped lang="scss">
.report-position-wrapper {
  min-height: 100vh;
}

.report-position-container {
  min-height: 100vh;
  background: #f7f8fa;
  position: relative;
  z-index: 10;

  .share-box {
    position: fixed;
    bottom: 3.2rem;
    right: -0.907rem;
    z-index: 999;
    width: 1.653rem;
    height: 0.96rem;
    background: linear-gradient(132deg, #eb4654 0%, #ec3e33 100%);
    box-shadow: 0 0.16rem 0.32rem 0.027rem rgba(220, 54, 68, 0.2);
    border-radius: 0.587rem 0 0 0.587rem;
    img {
      width: 0.427rem;
      margin-left: 0.267rem;
      margin-top: 0.267rem;
    }
  }

  .banner {
    width: 100%;
    height: auto;
    position: absolute;
    z-index: -1;
  }

  .main-content {
    padding: 0.53rem 0.53rem 1.7rem 0.53rem;

    .content-box {
      background: #fff;
      border-radius: 0.27rem;
      padding: 0.43rem;
      margin-bottom: 0.43rem;

      .right-text {
        font-size: 0.43rem;
        font-weight: 600;
        color: #3c3d42;
        margin-bottom: 0.11rem;
      }

      .sub-title-text {
        font-size: 0.29rem;
        color: #919499;
        margin-bottom: 0.63rem;
      }

      .score-img-box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.64rem;

        .img-score {
          width: 0.59rem;
          height: auto;
        }

        .padding-style {
          text-align: center;
          margin: 0 0.32rem;

          .number-all {
            font-size: 1.33rem;
            font-weight: bold;
            color: var(--main-color);


            .gray-score {
              color:rgba(102, 102, 102, 0.5);
              font-size: 0.43rem;
            }
          }

          .gray-title {
            font-size: 1.33rem;
            color:rgba(102, 102, 102, 0.5);
          }

          .special-text {
            font-size: 0.32rem;
            color: #666;
          }
        }
      }
      .msg-txt {
        font-size: 0.29rem;
        color: rgba(102, 102, 102, 0.5);
        line-height: 1.5;
      }

      .tips-msg-txt {
        font-size: 0.29rem;
        color: #D65B00;
        margin-bottom: 0.21rem;
        border-radius: 0.16rem;
        background: rgba(255, 144, 33, 0.1);
        box-sizing: border-box;
        padding: 0.21rem 0.32rem;
      }

      .score-box {
        .score-center-box {
          display: flex;
          align-items: center;
          background: rgba(247, 248, 250, 0.6);
          border-radius: 0.16rem;
          height: 2.24rem;

          .score-item {
            flex: 1;
            text-align: center;
            position: relative;

            &:not(:last-child)::after {
              content: '';
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 0.01rem;
              height: 0.85rem;
              background: #EBECF0;
            }

            .score-item-t {
              font-size: 0.48rem;
              font-weight: bold;
              color: #3c3d42;
              margin-bottom: 0.13rem;

              &.score-item-h {
                color: #ff7e56;
              }
            }

            .score-item-b {
              font-size: 0.32rem;
              color: #666;
            }
          }
        }
      }
      .tips-box {
        background: rgba(255, 144, 33, 0.1);
        border-radius: 0.16rem;
        padding: 0.21rem 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #D65B00;
        font-size: 0.29rem;
        margin-top: 0.43rem;
        margin-bottom: -0.22rem;
      }

      .list-area {
        margin: 0.43rem 0;

        .list-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 1.71rem;
          width: 100%;
          background: rgba(247, 248, 250, 0.6);
          border-radius: 0.16rem;
          padding: 0 0.43rem;
          box-sizing: border-box;
          margin-bottom: 0.21rem;
          &:last-of-type {
            margin-bottom: 0;
          }

          .left {
            display: flex;
            align-items: center;

            .img {
              width: 0.53rem;
              margin-right: 0.11rem;
            }

            .text {
              font-size: 0.37rem;
              color: #22242E;
            }
          }

          .right {
            display: flex;
            align-items: center;

            .num {
              font-size: 0.53rem;
              font-weight: bold;
              color: #3C3D42;
              margin-right: 0.107rem;
            }

            .text {
              font-size: 0.32rem;
              color: #3C3D42;
            }

            .red-text {
              font-size: 0.32rem;
              color: #EC3E33;
            }
            .gray-text {
              color: #C2C5CC;
              font-size: 0.32rem;
            }

            .yellow-text {
              font-size: 0.32rem;
              color: #fa9025;
            }

            .btn {
              width: 1.87rem;
              height: 0.75rem;
              background: var(--main-color);
              color: #fff;
              border-radius: 0.16rem;
              font-size: 0.32rem;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }

      .text-box {
        margin-top: 0.533rem;

        .exam-name {
          display: flex;
          margin-bottom: 0.267rem;

          .label {
            font-size: 0.373rem;
            color: #919499;
            min-width: 2.133rem;
          }

          .text-ellipsis-2 {
            flex: 1;
            font-size: 0.373rem;
            color: #3c3d42;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .same-job-rank {
      background: #fff;
      border-radius: 0.27rem;
      padding: 0.53rem 0.32rem 0.32rem 0.32rem;
      box-sizing: border-box;
      margin-bottom: 0.533rem;

      .top-pd-style {
        padding: 0 0.11rem;
        .title-area {
          display: flex;
          align-items: center;
          margin-bottom: 0.53rem;

          .img {
            width: 0.53rem;
            margin-right: 0.11rem;
          }

          .title {
            font-size: 0.43rem;
            font-weight: bold;
            color: #3c3d42;
          }
        }

        .line {
          height: 0.01rem;
          background: #EBECF0;
          margin-top: 0.32rem;
          margin-bottom: 0.51rem;
        }
      }
      .top-area {
        .list-item {
          display: flex;
          margin-bottom: 0.21rem;
          box-sizing: border-box;
          padding: 0.21rem;
          border-radius: 0.11rem;
          &:nth-of-type(2n + 1) {
            background: rgba(247, 248, 250, 0.5);
          }

          .left-text {
            width: 1.9rem;
            font-size: 0.35rem;
            color: #919499;
            min-width: 1.39rem;
            text-align: left;
            line-height: 1.2;
          }

          .right-text {
            flex: 1;
            font-size: 0.35rem;
            color: #3c3d42;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: bold;
            line-height: 1.2;
          }
        }
      }


      .score-rank-box {
        margin-bottom: 0.53rem;

        .scroll-list {
          width: 100%;
          overflow-x: auto;
          display: flex;
          align-items: center;
          white-space: nowrap;

          .scroll-list-item {
            padding: 0.19rem 0.48rem 0.21rem 0.48rem;
            box-sizing: border-box;
            color: #3c3d42;
            font-size: 0.32rem;
            border-radius: 0.16rem;
            background: #f7f8fa;
            margin-right: 0.21rem;
            position: relative;
            margin-bottom: 0.16rem;
            cursor: pointer;

            &.active {
              background: var(--main-color);
              color: #ffffff;

              .img {
                position: absolute;
                bottom: -0.13rem;
                left: 50%;
                transform: translateX(-50%);
                width: 0.24rem;
                height: 0.16rem;
              }
            }
          }
        }
        .scroll-list::-webkit-scrollbar {
          display: none; /* Chrome/Safari/Edge */
        }
      }
    }
    .menu-content {
      min-height: 7.47rem;
      position: relative;
      z-index: 1;
    }
    .rank-list {
      .rank-top {
        display: flex;
        padding-left: 0.21rem;
        margin-bottom: 0.16rem;
        .tit {
          font-size: 0.32rem;
          color: #919499;
        }
        .center {
          flex: 1;
          min-width: 0;
          padding-left: 0.43rem;
        }
        .score-style {
          width: 17%;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .rank-item {
        display: flex;
        align-items: center;
        padding: 0.27rem 0;
        &.user-my {
          background: rgba(220, 54, 68, 0.05);
          border-radius: 0.11rem;
          .number {
            color: #3c3d42 !important;
          }
          .num {
            color: #ec3e33;
          }
          .score-s {
            font-weight: bold;
          }
          .name {
            color: #3c3d42 !important;
            font-size: 0.32rem;
          }
          .me {
            background: #ec3e33;
            color: #fff;
            border-radius: 0.1rem;
            margin-left: 0.21rem;
            font-size: 0.29rem;
            height: 0.43rem;
            padding: 0.03rem 0.08rem;
            box-sizing: border-box;
          }
        }
        .number {
          font-size: 0.32rem;
          color: #c2c5cc;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1rem;
          .img {
            width: 0.53rem;
          }
        }
        .score-s {
          color: #3c3d42;
          font-size: 0.32rem;
        }
        .user {
          flex: 1;
          min-width: 0;
          padding-left: 0.24rem;
          display: flex;
          align-items: center;
          .imgbox {
            width: 0.53rem;
            height: 0.53rem;
            min-width: 0.53rem;
            border-radius: 50%;
          }
          .name {
            max-width: 3.6rem;
            color: #919499;
            font-size: 0.32rem;
            padding-left: 0.11rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .score-s {
          width: 17%;
          text-align: center;
        }
        .num {
          font-size: 0.32rem;
          color: #3c3d42;
        }
      }
    }
  }

  .footer-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    padding: 0.4rem 0.533rem;
    background: #fff;
    box-shadow: 0 -0.053rem 0.267rem rgba(0, 0, 0, 0.1);

    .rank-btn {
      flex: 1;
      padding: 0.32rem;
      background: var(--main-color);
      color: #fff;
      text-align: center;
      border-radius: 0.213rem;
      margin-right: 0.267rem;
    }

    .see-question {
      flex: 1;
      padding: 0.32rem;
      background: #f7f8fa;
      color: #3c3d42;
      text-align: center;
      border-radius: 0.213rem;
    }

    .all-btn {
      width: 100%;
      padding: 0.32rem;
      background: var(--main-color);
      color: #fff;
      text-align: center;
      border-radius: 0.213rem;
    }
  }

  .share-tip-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;

    .maks-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .lines {
      position: absolute;
      width: 5.333rem;
      height: auto;
    }

    .tips {
      position: absolute;
      width: 8rem;
      height: auto;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .no-data-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 1.067rem 0.533rem;

    .no-data-content {
      text-align: center;

      .no-data-img {
        width: 6.4rem;
        height: auto;
        margin-bottom: 0.533rem;
      }

      .no-data-text {
        font-size: 0.373rem;
        color: #919499;
      }
    }

    .refresh-btn {
      margin-top: 0.8rem;
      padding: 0.32rem 0.8rem;
      background: var(--main-color);
      color: #fff;
      border-radius: 0.533rem;
      font-size: 0.373rem;
    }
  }
}
.fix-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  border-radius: 0.16rem;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff6a4d;
  font-size: 0.37rem;
  font-weight: bold;
}
</style>